import React from 'react';
import { Formik } from 'formik';

import {
	ArcGisSettingsFormValues,
	IntegrationInfo,
} from '../../../types/integration.types';
import { useGlobalization } from '@Translations/useGlobalization';
import { arcGisSettingsSchema } from './arcGisSettings.schema';

const initialValues: ArcGisSettingsFormValues = {
	syncSettings: '--',
	integrationInfo: {} as IntegrationInfo,
};

interface ArcGisSettingsFormProps {
	children: React.ReactNode;
	initialValues?: ArcGisSettingsFormValues;
}

export default function ArcGisSettingsForm({
	children,
	initialValues: initialValuesProp,
}: ArcGisSettingsFormProps) {
	const { t } = useGlobalization();
	return (
		<Formik
			initialValues={initialValuesProp || initialValues}
			onSubmit={() => void 0}
			validationSchema={arcGisSettingsSchema(t)}
			enableReinitialize>
			{() => <div>{children}</div>}
		</Formik>
	);
}
